import React from 'react';
import PropTypes from 'prop-types';

/* eslint-disable max-len */
const Hoist = (props) => {
  const { height, width, fill, stroke, className } = props;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 60 60"
      fill={fill}
      stroke={stroke}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0)">
        <path
          d="M18.9316 7.04688H35.9945V10.0942H33.1004L25.0258 20.8598V21.3676C25.0258 21.5418 25.0514 25.6809 27.274 29.8534C27.6005 30.4665 27.9848 31.0979 28.4366 31.727L37.108 23.1881L29.0475 20.5758L34.6239 13.141H40.0784L45.7246 25.9806L40.3752 24.2469L30.4509 34.0195C33.0771 36.467 37.0652 38.4303 43.1034 38.4303H43.9382L50.2095 28.6101L42.067 10.0942H39.0414V7.04688H42.0883V4H12.8375V49.906H9.79041V56H12.8373V52.9529H42.0887V56H45.1356V49.906H18.9316V7.04688Z"
          fill="#009BB3"
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width="52" height="52" fill="white" transform="translate(4 4)" />
        </clipPath>
      </defs>
    </svg>
  );
};
/* eslint-enable max-len */

Hoist.defaultProps = {
  className: null,
};

Hoist.propTypes = {
  height: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired,
  stroke: PropTypes.string.isRequired,
  fill: PropTypes.string.isRequired,
  className: PropTypes.string,
};
export default Hoist;
